"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toArray_1 = __importDefault(require("lodash/toArray"));
var json_1 = require("../helpers/json");
var queryString_1 = require("../helpers/queryString");
var OnlineDriversEd = /** @class */ (function () {
    function OnlineDriversEd($http, UserService, APPURL) {
        this.$http = $http;
        this.UserService = UserService;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: this.APPURL + "/api/v1/online-de",
            UPDATE: this.APPURL + "/api/v1/online-de",
            CREATE: this.APPURL + "/api/v1/online-de",
        };
        this.cacheResponse = this.cacheResponse.bind(this);
        this.cacheUsers = this.cacheUsers.bind(this);
        this.cacheUser = this.cacheUser.bind(this);
        this.extract = this.extract.bind(this);
        this.viewFinals = this.viewFinals.bind(this);
    }
    OnlineDriversEd.prototype.extract = function (result) {
        return result.data;
    };
    OnlineDriversEd.prototype.cacheUsers = function (result) {
        var users = this.extract(result);
        if (users.hasOwnProperty("students")) {
            if (users.students.hasOwnProperty("data")) {
                users.students.data.forEach(function (user) {
                    var metadata = {};
                    user.usermeta.forEach(function (meta) {
                        metadata[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                            ? JSON.parse(meta.meta_value)
                            : meta.meta_value;
                    });
                    user.usermeta = metadata;
                });
                users.students.data = (0, toArray_1.default)(users.students.data);
                return users;
            }
            if (typeof users.students === "object") {
                users.students = (0, toArray_1.default)(users.students);
            }
        }
        if (users.instructors && typeof users.instructors === "object") {
            if (users.instructors.hasOwnProperty("data")) {
                users.instructors.data = (0, toArray_1.default)(users.instructors.data);
                return users;
            }
            users.instructors = (0, toArray_1.default)(users.instructors);
        }
        return users;
    };
    OnlineDriversEd.prototype.cacheUser = function (result) {
        var user = this.extract(result).user;
        return user;
    };
    OnlineDriversEd.prototype.cacheResponse = function (result) {
        return this.extract(result);
    };
    OnlineDriversEd.prototype.updateOnlineDriversEdFields = function (user) {
        return this.$http
            .put(this.URLS.FETCH + "/user/" + user.id, {
            ode_required: user.ode_required,
            ode_completed: user.ode_completed,
        })
            .then(this.cacheResponse);
    };
    OnlineDriversEd.prototype.viewFinals = function (data) {
        return this.$http
            .get(this.URLS.FETCH + "/finals?" + (0, queryString_1.toQueryString)(data))
            .then(this.cacheResponse);
    };
    OnlineDriversEd.prototype.getFeatureDetails = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResponse);
    };
    OnlineDriversEd.prototype.purchase = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/manage/purchase", data)
            .then(this.cacheResponse);
    };
    return OnlineDriversEd;
}());
OnlineDriversEd.$inject = ["$http", "UserService", "APPURL"];
exports.default = OnlineDriversEd;
